import { Stack } from "@mui/material";
import { FilterLabel } from "./FilterLabel";
import { FilterContent } from "./FilterContent";

export const FilterRow = ({
  filter,
  dispatch,
  searchQuery,
  resetFilters,
  updateCheckedBoxes,
  updateRange,
  updateNominalRange,
  valueForColor,
  loggedIn,
  switchToFancyColors,
  sendTo,
}) => (
  <Stack
    direction="row"
    spacing={2}
    sx={{ marginLeft: "2rem", marginBottom: "1.5rem" }}
    key={filter.name}
  >
    <FilterLabel filter={filter} dispatch={dispatch} />
    <FilterContent
      filter={filter}
      searchQuery={searchQuery}
      resetFilters={resetFilters}
      updateCheckedBoxes={updateCheckedBoxes}
      updateRange={updateRange}
      updateNominalRange={updateNominalRange}
      valueForColor={valueForColor}
      loggedIn={loggedIn}
      switchToFancyColors={switchToFancyColors}
      sendTo={sendTo}
    />
  </Stack>
);
